/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseEingabelisteFeldGroesse } from './DatabaseEingabelisteFeldGroesse';
import {
    DatabaseEingabelisteFeldGroesseFromJSON,
    DatabaseEingabelisteFeldGroesseFromJSONTyped,
    DatabaseEingabelisteFeldGroesseToJSON,
} from './DatabaseEingabelisteFeldGroesse';
import type { DatabaseEingabelisteHinzufuegen } from './DatabaseEingabelisteHinzufuegen';
import {
    DatabaseEingabelisteHinzufuegenFromJSON,
    DatabaseEingabelisteHinzufuegenFromJSONTyped,
    DatabaseEingabelisteHinzufuegenToJSON,
} from './DatabaseEingabelisteHinzufuegen';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseKlappzeile } from './DatabaseKlappzeile';
import {
    DatabaseKlappzeileFromJSON,
    DatabaseKlappzeileFromJSONTyped,
    DatabaseKlappzeileToJSON,
} from './DatabaseKlappzeile';
import type { DatabasePageBlock } from './DatabasePageBlock';
import {
    DatabasePageBlockFromJSON,
    DatabasePageBlockFromJSONTyped,
    DatabasePageBlockToJSON,
} from './DatabasePageBlock';
import type { DatabasePageBlockActionType } from './DatabasePageBlockActionType';
import {
    DatabasePageBlockActionTypeFromJSON,
    DatabasePageBlockActionTypeFromJSONTyped,
    DatabasePageBlockActionTypeToJSON,
} from './DatabasePageBlockActionType';

/**
 * 
 * @export
 * @interface DatabaseEingabelistePageBlock
 */
export interface DatabaseEingabelistePageBlock extends DatabasePageBlock {
    /**
     * Die Unterdatenbank, aus der die Zeilen kommen.
     * @type {string}
     * @memberof DatabaseEingabelistePageBlock
     */
    childDatabaseId?: string;
    /**
     * Das Datenfeld, das je Zeile eingetragen wird — bei der
     * Minigolfkarte der Name des Spielers.
     * @type {string}
     * @memberof DatabaseEingabelistePageBlock
     */
    feldId?: string;
    /**
     * Mengenvorgabe: hoechstens so viele Zeilen. 0 oder leer heisst ohne
     * Grenze.
     * @type {number}
     * @memberof DatabaseEingabelistePageBlock
     */
    menge?: number;
    /**
     * 
     * @type {DatabaseEingabelisteHinzufuegen}
     * @memberof DatabaseEingabelistePageBlock
     */
    hinzufuegen?: DatabaseEingabelisteHinzufuegen;
    /**
     * Ein Kreuz je Zeile; fragt vor dem Loeschen nach.
     * @type {boolean}
     * @memberof DatabaseEingabelistePageBlock
     */
    loeschenErlaubt?: boolean;
    /**
     * Eine leere Zeile steht von Anfang an da, statt erst auf Knopfdruck
     * zu erscheinen.
     * @type {boolean}
     * @memberof DatabaseEingabelistePageBlock
     */
    erstesFeldGeoeffnet?: boolean;
    /**
     * Der graue Text in der leeren Zeile, etwa „Spieler eintragen".
     * @type {string}
     * @memberof DatabaseEingabelistePageBlock
     */
    platzhalter?: string;
    /**
     * 
     * @type {DatabaseEingabelisteFeldGroesse}
     * @memberof DatabaseEingabelistePageBlock
     */
    feldGroesse?: DatabaseEingabelisteFeldGroesse;
    /**
     * Nur bei `feldGroesse: MIT_RAND`: um wie viele Pixel das Feld AN
     * JEDER SEITE gekuerzt wird (Betreiber 16.09.2026: „Besser als %
     * waeren Pixel, die man eintragen kann. … Dies wird an jeder Seite
     * gekuerzt.").
     * 
     * Ohne Angabe (oder 0) steht das Feld wie bei KOMPLETT.
     * @type {number}
     * @memberof DatabaseEingabelistePageBlock
     */
    randBreite?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEingabelistePageBlock
     */
    schriftart?: string;
    /**
     * Mit Einheit, etwa „14px".
     * @type {string}
     * @memberof DatabaseEingabelistePageBlock
     */
    schriftgroesse?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEingabelistePageBlock
     */
    schriftfarbe?: string;
    /**
     * Hintergrund des EINGABEFELDES, nicht des Bausteins.
     * @type {string}
     * @memberof DatabaseEingabelistePageBlock
     */
    hintergrund?: string;
    /**
     * Rahmen des Eingabefeldes in Pixeln; 0 heisst kein Rahmen.
     * @type {number}
     * @memberof DatabaseEingabelistePageBlock
     */
    rahmenBreite?: number;
    /**
     * Abrundung des Eingabefeldes in Pixeln.
     * @type {number}
     * @memberof DatabaseEingabelistePageBlock
     */
    rahmenRundung?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEingabelistePageBlock
     */
    rahmenFarbe?: string;
}

/**
 * Check if a given object implements the DatabaseEingabelistePageBlock interface.
 */
export function instanceOfDatabaseEingabelistePageBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseEingabelistePageBlockFromJSON(json: any): DatabaseEingabelistePageBlock {
    return DatabaseEingabelistePageBlockFromJSONTyped(json, false);
}

export function DatabaseEingabelistePageBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseEingabelistePageBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabasePageBlockFromJSONTyped(json, ignoreDiscriminator),
        'childDatabaseId': !exists(json, 'childDatabaseId') ? undefined : json['childDatabaseId'],
        'feldId': !exists(json, 'feldId') ? undefined : json['feldId'],
        'menge': !exists(json, 'menge') ? undefined : json['menge'],
        'hinzufuegen': !exists(json, 'hinzufuegen') ? undefined : DatabaseEingabelisteHinzufuegenFromJSON(json['hinzufuegen']),
        'loeschenErlaubt': !exists(json, 'loeschenErlaubt') ? undefined : json['loeschenErlaubt'],
        'erstesFeldGeoeffnet': !exists(json, 'erstesFeldGeoeffnet') ? undefined : json['erstesFeldGeoeffnet'],
        'platzhalter': !exists(json, 'platzhalter') ? undefined : json['platzhalter'],
        'feldGroesse': !exists(json, 'feldGroesse') ? undefined : DatabaseEingabelisteFeldGroesseFromJSON(json['feldGroesse']),
        'randBreite': !exists(json, 'randBreite') ? undefined : json['randBreite'],
        'schriftart': !exists(json, 'schriftart') ? undefined : json['schriftart'],
        'schriftgroesse': !exists(json, 'schriftgroesse') ? undefined : json['schriftgroesse'],
        'schriftfarbe': !exists(json, 'schriftfarbe') ? undefined : json['schriftfarbe'],
        'hintergrund': !exists(json, 'hintergrund') ? undefined : json['hintergrund'],
        'rahmenBreite': !exists(json, 'rahmenBreite') ? undefined : json['rahmenBreite'],
        'rahmenRundung': !exists(json, 'rahmenRundung') ? undefined : json['rahmenRundung'],
        'rahmenFarbe': !exists(json, 'rahmenFarbe') ? undefined : json['rahmenFarbe'],
    };
}

export function DatabaseEingabelistePageBlockToJSON(value?: DatabaseEingabelistePageBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabasePageBlockToJSON(value),
        'childDatabaseId': value.childDatabaseId,
        'feldId': value.feldId,
        'menge': value.menge,
        'hinzufuegen': DatabaseEingabelisteHinzufuegenToJSON(value.hinzufuegen),
        'loeschenErlaubt': value.loeschenErlaubt,
        'erstesFeldGeoeffnet': value.erstesFeldGeoeffnet,
        'platzhalter': value.platzhalter,
        'feldGroesse': DatabaseEingabelisteFeldGroesseToJSON(value.feldGroesse),
        'randBreite': value.randBreite,
        'schriftart': value.schriftart,
        'schriftgroesse': value.schriftgroesse,
        'schriftfarbe': value.schriftfarbe,
        'hintergrund': value.hintergrund,
        'rahmenBreite': value.rahmenBreite,
        'rahmenRundung': value.rahmenRundung,
        'rahmenFarbe': value.rahmenFarbe,
    };
}

